import React from 'react';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import ModalClose from '@mui/joy/ModalClose';
import Box from '@mui/joy/Box';
import Card from '@mui/joy/Card';
import Typography from '@mui/joy/Typography';
import ReactMarkdown from 'react-markdown';
import DonationForm from '../Donation/DonationForm';
import { Event as EventItem } from '../../models/all';

interface EventPreviewProps {
  open: boolean;
  onClose: () => void;
  event: EventItem;
}

export default function EventPreview({ open, onClose, event }: EventPreviewProps) {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog layout="fullscreen" sx={{ p: 0 }}>
        <ModalClose />
        <Box sx={{ p: 2, maxWidth: 'md', mx: 'auto' }}>
          <Card>
            <Typography level="h2" gutterBottom>
              {event.title}
            </Typography>
            {event.poster && (
              <Box
                component="img"
                src={event.poster}
                alt={event.title}
                sx={{ width: '100%', mb: 2 }}
              />
            )}
            {event.description && (
              <Box sx={{ mt: 2 }}>
                <ReactMarkdown>{event.description}</ReactMarkdown>
              </Box>
            )}
          </Card>
          <Box sx={{ mt: 2 }}>
            <DonationForm eventId={event.id} eventData={event} />
          </Box>
        </Box>
      </ModalDialog>
    </Modal>
  );
}
